import força_0 from './0.png';
import força_1 from './1.png';
import força_2 from './2.png';
import força_3 from './3.png';
import força_4 from './4.png';
import força_5 from './5.png';
import força_6 from './6.png';
import força_7 from './7.png';
import força_8 from './8.png';
import força_9 from './9.png';
import força_10 from './10.png';
import força_11 from './11.png';
import força_12 from './12.png';
import força_no_representable from './13.png';

export default {
    força_0,
    força_1,
    força_2,
    força_3,
    força_4,
    força_5,
    força_6,
    força_7,
    força_8,
    força_9,
    força_10,
    força_11,
    força_12,
    força_no_representable
};



// WEBPACK FOOTER //
// ./src/images/vent/index.js